export default "__VITE_ASSET__DcJfQme0__"